import { useState, useEffect } from 'react';
import { format, formatDistanceToNow } from 'date-fns';

interface CacheStatusProps {
  lastRefreshed: Date | null;
}

export default function CacheStatus({ lastRefreshed }: CacheStatusProps) {
  const [relativeTime, setRelativeTime] = useState<string>('');

  useEffect(() => {
    if (!lastRefreshed) {
      setRelativeTime('');
      return;
    }

    const updateRelativeTime = () => {
      try {
        setRelativeTime(formatDistanceToNow(lastRefreshed, { addSuffix: true }));
      } catch (error) {
        console.error('[CacheStatus] Error formatting relative time:', error);
        setRelativeTime('');
      }
    };

    // Update immediately
    updateRelativeTime();

    // Update every minute
    const interval = setInterval(updateRelativeTime, 60000);

    return () => clearInterval(interval);
  }, [lastRefreshed]);

  if (!lastRefreshed) {
    return (
      <div className="text-sm text-neutral-secondary">
        No cache data
      </div>
    );
  }

  const absoluteTime = format(lastRefreshed, 'yyyy-MM-dd HH:mm:ss') + ' UTC';

  return (
    <div className="text-sm text-neutral-secondary">
      <div className="font-medium">Last refreshed:</div>
      <div className="text-xs">{absoluteTime}</div>
      {relativeTime && (
        <div className="text-xs italic">{relativeTime}</div>
      )}
    </div>
  );
}
